export const parseOrdering = (value: string): { [key in string]: 'ASC' | 'DESC' } => {
  if (value.match(/^-/)) return { [value.slice(1)]: 'DESC' };
  return { [value]: 'ASC' };
};
